<script setup lang="ts">
import { onUnmounted, ref, watchEffect } from "vue";
import { useDrop } from "@zyzgroup/core-web";

// for merge ce shadow-root styles
defineOptions({
  customOptions: {},
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    placeholder?: string;
  }>(),
  {
    placeholder: "drop file"
  }
);

const emits = defineEmits<{
  (event: "drop", files: File[]): void;
  (event: "yz-drop", files: File[]): void;
}>();

const zone = ref();
const isOver = ref(false);
let remove: () => void;

watchEffect(() => {
  if (!zone.value || remove) {
    return;
  }
  remove = useDrop(zone.value, {
    onEnter: () => {
      isOver.value = true;
    },
    onLeave: () => {
      isOver.value = false;
    },
    onDrop: (e, files) => {
      emits("drop", files);
      emits("yz-drop", files);
      // console.log(files);
      isOver.value = false;
    }
  });
});

onUnmounted(() => {
  remove?.();
});

defineExpose({});
</script>

<template>
  <div
    ref="zone"
    class="input-file-drop"
    :class="[isOver ? 'over' : '']"
  >
    <slot>{{ props.placeholder }}</slot>
  </div>
</template>

<style scoped>
.input-file-drop {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px dashed var(--yz-gap-common);
  color: var(--yz-gap-common);
}
.input-file-drop.over {
  border-color: var(--yz-font-common);
  color: var(--yz-font-common);
}
</style>
